import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CommdocList.html?raw';
import on from 'dojo/on';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import { ToasterHelpers } from "../../../more/Helpers";

class CommdocListV1 extends compose(_WidgetBaseSP) {
    templateString: any = template;

    constructor(projectId: string) {
        super(...(arguments as unknown as []));

        this.projectId = projectId;
    }

    private projectId: string;
    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    private entitylist: Array<any>;

    private filesTableLayout: StaticTable.RowConfig = {
        "attributes": ["$ClassPrintname", "doc_no", "ref_doc_status.description"],
        colNamesInternal: ["$ClassPrintname", "doc_no", "ref_doc_status.description", "files", "Download", "Aktionen"],
        "colspans": [1, 1, 1, 1, 1, 1],
        "headings": [(this as any).translations["General_Label_VtCommdocClass"], (this as any).translations["General_Label_DocNo"], (this as any).translations["General_Label_Status"], (this as any).translations["General_Label_DokFiles"], (this as any).translations["General_Label_Download"], (this as any).translations["General_Label_Actions"]],
        widths: ["25ch", "15ch", "13ch", null, "11ch", "14ch"],
        alignmentsHeading: [null, null, null, null, "center", "center"],
        alignmentsRow: [null, null, null, null, "center", "center"]
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.Commdoc>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;
        
        let icon: HTMLElement;
        if (!cell.tableRow["fileSelect"]) cell.tableRow["fileSelect"] = new SelectBox();

        this.UiModder.domStyle.set(cell.tableCellNode, "vertical-align", "middle");

        switch (colName) {
            case "Download":

                icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["CommdocList_ButtonTitle_Download"]);
                on(icon, "click", lang.hitch(this, this._downloadFile, cell.tableRow["fileSelect"]));
                if (entity.vt_files.length < 1) this.disableNode(icon);

                return true;
                break;
            case "Aktionen":

                icon = this.createFontawesomeIcon("fas fa-check hoverTxtPrimary secondaryText w3-margin-right", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["CommdocList_ButtonTitle_Close"]);
                on(icon, "click", lang.hitch(this, this._onClick_closeCommdoc, entity));
                if (entity.ref_doc_status.is_finished || entity.is_notRelevant) this.disableNode(icon);

                icon = this.createFontawesomeIcon("fas fa-ban hoverTxtPrimary secondaryText", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["CommdocList_ButtonTitle_AsNotRelevant"]);
                on(icon, "click", lang.hitch(this, this._onClick_setToNotRelevantCommdoc, entity));
                if (entity.ref_doc_status.is_finished || entity.is_notRelevant) this.disableNode(icon);
                return true;
                break;
            case "files":

                let rowFileSelect: MdsLax<InstanceType<typeof SelectBox>> = cell.tableRow["fileSelect"];

                rowFileSelect.placeAt(node);

                if (entity.vt_files.length > 0) {

                    entity.vt_files.forEach(file => {

                        rowFileSelect.addOption(file.ID, file.filename);
                    });
                } else {

                    rowFileSelect.addOption(null, this.translations["CommdocList_FileSelect_NoFiles"]);
                    this.disableNode(rowFileSelect.domNode);
                }
                rowFileSelect.constructOptions();
                return true;
                break;
        }

        return false;
    }

    private _onClick_closeCommdoc(entity: VAM2types.Commdoc): void {

        let dlg = new GenericDialog()
        dlg.show(
            this.translations["CommdocList_Message_CloseDocument"],
            this.translations["CommdocList_ButtonTitle_Close"],
            null,
            "fas fa-question-circle",
            "yesno",
            lang.hitch(this, this._closeCommdoc, entity)
        )
    }

    private _closeCommdoc(entity: VAM2types.Commdoc, response): void {

        if (response !== 2) return;

        this.StandbyStart();
        let requestUrl = window.appRoot + "ProjectWizard/CloseCommdocById";

        this.RequestManager.post(
            requestUrl,
            {
                id: entity.ID
            },
            lang.hitch(this, this.onCloseCommdocResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private onCloseCommdocResponse(): void {

        this.showToast({
            title: this.translate("CommdocList_Toast_DocumentClosed"),
            options: {
                ID: "saved",
                //timeout: 5000
            },
            iconClass: ToasterHelpers.ToasterIcons.save
        });
        this.refreshCommdocList();
    }

    private _downloadFile(fileSelect: MdsLax<InstanceType<typeof SelectBox>>): void {

        let fileId = fileSelect.getValue();
        console.log("FILE", fileId);

        if (!fileId) return;
        
        window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${fileId}`);
    }

    private _onClick_setToNotRelevantCommdoc(entity: VAM2types.Commdoc): void {

        let dlg = new GenericDialog()
        dlg.show(
            this.translations["CommdocList_Message_AsNotRelevant"],
            this.translations["CommdocList_ButtonTitle_AsNotRelevant"],
            null,
            "fas fa-question-circle",
            "yesno",
            lang.hitch(this, this._setToNotRelevantCommdoc, entity)
        )
    }
    private _setToNotRelevantCommdoc(entity: VAM2types.Commdoc, response): void {

        if (response !== 2) return;

        this.StandbyStart();
        let requestUrl = window.appRoot + "ProjectWizard/SetToNotRelevantCommdocById";

        this.RequestManager.post(
            requestUrl,
            {
                id: entity.ID
            },
            lang.hitch(this, this.onSetToNotRelevantCommdocResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private onSetToNotRelevantCommdocResponse(): void {

        this.showToast({
            title: this.translate("CommdocList_Toast_DocumentSetToNotRelevant"),
            options: {
                ID: "notRelevant",
                //timeout: 5000
            },
            iconClass: ToasterHelpers.ToasterIcons.save
        });
        this.refreshCommdocList();
    }

    private _emitHandle: any = null;

    private drawTable(): void {

        this.tableContainer.innerHTML = null;
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();

        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));
        this.table.addLineConfig(this.filesTableLayout);

        this.table.setCyAttribute("CommdocList");
        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //let list = this.entitylist.filter(x => x["state"] != "deleted");

        this.table.setData(this.entitylist);
    }

    setup(data: Array<any>) {

        this.entitylist = data;
        this.drawTable();

        this.emit("SetupCommdocList", this.entitylist.length !== 0);

        this.StandbyStop();
    }

    refreshCommdocList(): void {

        this.getCommdocList();
    }

    private getCommdocList(): void {

        this.StandbyStart();
        let requestUrl = window.appRoot + "ProjectWizard/GetCommdocList";

        this.RequestManager.post(
            requestUrl,
            {
                id: this.projectId
            },
            lang.hitch(this, this.setup),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private _showErrorMessage(err: any) {

        alert(err.Message);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.getCommdocList();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommdocListV1);
